import React, { useEffect, useRef, useState } from "react";
import { filter } from "lodash";
import { Title } from '../../components/Text';
import { Table, TableContainer } from '../../components/Table';
import { Content } from "../../components/Layout";
import { Flex } from '../../components/Flex';
import { SearchBox } from "./SearchBox";
import { PageContentPagination } from "./PageContentPagination";
import { Breadcrumbs } from "../../components/Breadcrumbs";
import { FilterButton } from "./FilterButton";

const PageContent = ({
    title,
    data,
    header,
    footer,
    columns=[],
    searchOptions,
    breadcrumbs,
    loading,
    sortColumn,
    sortOrder,
    currentPage,
    total,
    context,
    filterOptions,
    setQueryParams,
    savedFilters,
    applyFilter,
    selectedFilter,
    saveQueryFilter,
    saveFilterChanges,
    deleteQueryFilter,
    isFilterDirty
}) => {

    const [width, setWidth] = useState(0);
    const ref = useRef(null);

    useEffect(() => {
        if (!ref.current) return;
        const observer = new ResizeObserver(entries => {
            setWidth(entries[0].contentRect.width)
        });
        observer.observe(ref.current);
        return () => ref.current && observer.unobserve(ref.current)
    }, []);

    const calcHeight = () => {
        let titleHeight = title || breadcrumbs ? 40 : 0, footerHeight = total || footer ? 52 : 0,
        searchHeight = document.getElementById("search-box") ? document.getElementById("search-box").clientHeight + 12 : 0;

        return "calc(100% - " + (titleHeight + searchHeight + footerHeight) +"px)"
    };

    return(
        <Content id="page-content" ref={ref}>
            {breadcrumbs
                ? <Title h4 isLoading={loading}><Breadcrumbs items={breadcrumbs} /></Title>
                : title
                    ? <Flex id="page-title" align="center" justify="space-between">
                        {typeof title === "string"
                            ? <Title h3 capitalize nowrap>{title}</Title>
                            : title
                        }
                    </Flex>
                    : null}
            <Flex id="search-box" gap={{ right: 12 }} width="100%" style={{ maxWidth: "100%"}} >
                <SearchBox
                    context={context}
                    searchOptions={searchOptions}
                    setQueryParams={setQueryParams}
                    filterOptions={filterOptions}
                    selectedFilter={selectedFilter}
                    saveQueryFilter={saveQueryFilter}
                    saveFilterChanges={saveFilterChanges}
                    deleteQueryFilter={deleteQueryFilter}
                    hasChanges={isFilterDirty}
                    width={width}
                />
                {Array.isArray(savedFilters) && savedFilters.length
                    ? <FilterButton options={savedFilters} applyFilter={applyFilter} deleteQueryFilter={deleteQueryFilter} selected={selectedFilter}/>
                    : null}
                {header}
            </Flex>
            <TableContainer height={calcHeight()}>
                {Array.isArray(columns) && columns.length
                    ? <Table
                        columns={filter(columns, col => col.dataIndex && col.visible !== false)}
                        dataSource={data}
                        loading={loading}
                        setSorting={(payload) => setQueryParams(payload)}
                        sortOrder={sortOrder}
                        sortColumn={sortColumn}
                        total={total}
                    />
                    : null}
            </TableContainer>
            {footer || total
                ? <Flex id="page-footer">
                    <Flex flex={1} gap={{ right: 20}}>{footer}</Flex>
                    <PageContentPagination page={currentPage} total={total} changePage={(number) => setQueryParams({ page: number })}/>
                </Flex>
                : null
            }
        </Content>
    );
};

export { PageContent };